<!--
import { setTimeout } from 'timers';
 * @Description:
 * @Author: Li Jiahui
 * @Date: 2020-11-09 17:32:25
 * @LastEditTime: 2022-04-13 16:04:31
 * @LastEditors: Please set LastEditors
-->
<template>
    <div class="search-empty">
        <!-- 内容 -->
        <div class="empty-content" :class="type=='eatPage'?'empty-content-bg':''">
            <div class="empty-img"><img src="../../assets/images/common/xiaohe1.png"/></div>
            <template v-if="type!='eatPage'">
              <p class="empty-warn">找不到任何与“ <span>{{keyWord}}</span> ”匹配的内容，{{tipText}}</p>
              <!-- <p class="back" @click="sensors"><a>返回</a></p> -->
            </template>
            <template v-else>
              <p class="empty-warn">Sorry，暂时没有找到相关内容，我们正在加班加点补充新的食物种类，欢迎您下次再来哦！</p>
              <!-- <p class="back"><a  @click="goBack">返回</a></p> -->
            </template>
        </div>
    </div>
</template>
<style lang="less" scoped>
.search-empty {
  height: 100%;
  background: #f7f7f7;
  .empty-content {
    .empty-img {
      width: 143px;
      height: 143px;
      margin: 0 auto;
      padding-top: 34px;
      img {
        width: 100%;
        display: block;
      }
    }
    .empty-warn {
      width: 212px;
      margin: 0 auto;
      text-align: center;
      font-size: @indexFontSize14;
      color: @expertFontColor51;
      line-height: 22px;
      span {
        color: @mainColor;
        word-break: break-all;
      }
    }
    p.back {
      margin-top: 12px;
      padding-bottom: 99px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 34px;
      a {
        width: 86px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #d7a85c
          linear-gradient(
            132deg,
            rgba(255, 255, 255, 0.5) 0%,
            rgba(255, 255, 255, 0) 100%
          );
        border-radius: 25px;
        font-size: @indexFontSize14;
        color: #ffffff;
        border-radius: 23px;
      }
    }
  }
}
</style>
<script>
export default {
  data() {
    return {
      tipText: "可以按月龄阶段或标签分类查查看噢~",
      backUrl: "/baby",
    };
  },
  props:["keyWord",'searchType',"type"],
  mounted() {
    if(this.type!='eatPage'){
      $(".search-empty").css(
        "height",
        $("body").height() - $(".van-search")[0].clientHeight - 36 + "px"
        );
        $(window).resize(function () {
        $(".search-empty").css(
            "height",
            $("body").height() - $(".van-search")[0].clientHeight - 36 + "px"
        );
        });
    }
    this.showTiptext(this.searchType);
  },
  methods: {
    showTiptext(type) {
      if(sessionStorage.getItem('searchVal') == 'cagechild'){
        this.tipText = "可以按标签分类查查看噢~";
        this.backUrl = "/cagechild";
        return false
      }
      switch (type) {
        case "baby":
          this.tipText = "可以按月龄阶段或标签分类查查看噢~";
          this.backUrl = "/baby";
          break;
        case "expertOnline":
          this.tipText = "可以按标签分类查查看噢~";
          this.backUrl = "/expertOnline";
          break;
        case "course":
          this.tipText = "可以按标签分类查查看噢~";
          this.backUrl = "/course";
          break;
        case "parentAudio":
          this.tipText = "可以按标签分类查查看噢~";
          this.backUrl = "/calendar";
          break;
        case "childSongs":
          this.tipText = "可以按标签分类查查看噢~";
          this.backUrl = "/calendar";
          break;
        case "home":
          this.tipText = "可以按标签分类查查看噢~";
          this.backUrl = "/home";
          break;
        case "foodColumn":
          this.tipText = "可以按标签分类查查看噢~";
          this.backUrl = "/foodColumn";
          break;
      }
    },
    // sensors() {
    //   sensors.track("NoSearchResultsButton", {
    //     key_word: this.keyWord,
    //     page_name: document.title,
    //   });
    //   setTimeout(() => {
    //     // 返回育儿音频列表
    //     if (this.searchType == "parentAudio") {
    //       this.$router.push({
    //         path: this.backUrl,
    //         query: {
    //           shareFrom: "audio",
    //         },
    //       });
    //       // 返回亲子儿歌列表
    //     } else if (this.searchType == "childSongs") {
    //       this.$router.push({
    //         path: this.backUrl,
    //         query: {
    //           shareFrom: "songs",
    //         },
    //       });
    //     } else {
    //       this.$router.push({ path: this.backUrl });
    //     }
    //   }, 200);
    // },
    // goBack() {
    //   this.$router.go(-1);
    // }
  },
};
</script>